<template>
  <div>
    <!-- Actions -->
    <div class="has-background-white has-shadow pa-md mb-xxs">
      <Workflow :client="client"
        @suspend:client="showSuspensionModal = true"
        @activate:client="showActivationModal = true"
      />
    </div>
    <!-- Content -->
    <div>
      <General />
    </div>
    <!-- Modal: Activate Client -->
    <b-modal
      has-modal-card
      scroll="keep"
      :active.sync="showActivationModal"
      :can-cancel="['x', 'esc']"
      ><ActivateClientModal :client="client" @client:saved="$emit('client:saved')" />
    </b-modal>
    <!-- Modal: Add Attachment -->
    <b-modal
      has-modal-card
      scroll="keep"
      :active.sync="showSuspensionModal"
      :can-cancel="['x', 'esc']"
      ><SuspendClientModal :client="client" @client:saved="$emit('client:saved')" />
    </b-modal>
  </div>
</template>

<script>
import General from '../components/Client/General'
import Workflow from '../components/Client/Workflow'
import ActivateClientModal from '@/components/Models/Client/Modals/ActivateClientModal'
import SuspendClientModal from '@/components/Models/Client/Modals/SuspendClientModal'

export default {
  components: {
    General,
    Workflow,
    ActivateClientModal,
    SuspendClientModal
  },
  data () {
    return {
      showSuspensionModal: false,
      showActivationModal: false
    }
  },
  props: {
    client: {
      type: Object,
      required: true
    }
  }
}
</script>
